export default __webpack_public_path__ + "static/media/banner1.f19a1e88.png";